export const BUSINESS_DETAILS_SECTION_ID = 'business-details-section';
export const BUSINESS_DETAILS_SECTION_TITLE = 'Business Details Section';
